import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { ChevronDown } from 'lucide-react';

type CollapsibleSectionProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export default function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = false,
  className = '',
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  return (
    <Card className={className}>
      <CardHeader className="p-4">
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="w-full text-left flex items-start gap-3"
        >
          <div
            className={`transform transition-transform duration-200 mt-1 ${open ? 'rotate-180' : ''}`}
          >
            <ChevronDown className="w-5 h-5 text-muted-foreground" />
          </div>
          <div className="flex-1">
            <CardTitle className="flex items-center gap-2">{title}</CardTitle>
            {subtitle && <div className="mt-2 text-sm text-muted-foreground">{subtitle}</div>}
          </div>
        </button>
      </CardHeader>

      {open && <CardContent>{children}</CardContent>}
    </Card>
  );
}
